[
  {
    "id": "SR-B7-ONDERWERP-KINDEREN-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "zinsontleding",
    "subSkill": "onderwerp",
    "familyId": "SR-ONDERWERP-VINDEN",
    "conceptId": "find_subject_in_sentence",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Wat is het onderwerp in de zin: 'De kinderen spelen buiten.'",
    "options": ["De kinderen", "spelen", "buiten", "De"],
    "correctAnswer": 0,
    "explanation": "Het onderwerp is wie of wat iets doet. Vraag: Wie spelen buiten? De kinderen. Dus 'de kinderen' is het onderwerp.",
    "distractorExplanations": {
      "1": "'Spelen' is de persoonsvorm (het werkwoord), niet het onderwerp.",
      "2": "'Buiten' is een bijwoordelijke bepaling — het vertelt waar ze spelen.",
      "3": "'De' is een lidwoord. Het hele onderwerp is 'de kinderen', niet alleen 'de'."
    }
  },
  {
    "id": "SR-B7-PV-GAAN-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "zinsontleding",
    "subSkill": "persoonsvorm",
    "familyId": "SR-PERSOONSVORM-VINDEN",
    "conceptId": "find_finite_verb",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Wat is de persoonsvorm in de zin: 'Morgen gaan wij naar het strand.'",
    "options": ["gaan", "Morgen", "wij", "strand"],
    "correctAnswer": 0,
    "explanation": "De persoonsvorm verandert als je de tijd verandert. 'Morgen gaan wij' → 'Gisteren gingen wij'. 'Gaan' verandert, dus dat is de persoonsvorm.",
    "distractorExplanations": {
      "1": "'Morgen' is een bijwoord van tijd — het vertelt wanneer.",
      "2": "'Wij' is het onderwerp — het vertelt wie.",
      "3": "'Strand' is een zelfstandig naamwoord."
    }
  },
  {
    "id": "SR-B7-ONDERWERP-BOOM-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "zinsontleding",
    "subSkill": "onderwerp",
    "familyId": "SR-ONDERWERP-VINDEN",
    "conceptId": "find_subject_in_sentence",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Wat is het onderwerp in de zin: 'Op het plein staat een grote boom.'",
    "options": ["een grote boom", "Op het plein", "staat", "grote"],
    "correctAnswer": 0,
    "explanation": "Wie of wat staat op het plein? Een grote boom. Let op: het onderwerp staat hier niet vooraan! In het Nederlands kan het onderwerp ook verderop in de zin staan.",
    "distractorExplanations": {
      "1": "'Op het plein' is een voorzetselgroep — het vertelt waar de boom staat.",
      "2": "'Staat' is de persoonsvorm (het werkwoord).",
      "3": "'Grote' is een bijvoeglijk naamwoord. Het hele onderwerp is 'een grote boom'."
    }
  },
  {
    "id": "SR-B7-PV-HEEFT-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "zinsontleding",
    "subSkill": "persoonsvorm",
    "familyId": "SR-PERSOONSVORM-VINDEN",
    "conceptId": "find_finite_verb",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Wat is de persoonsvorm in de zin: 'De hond heeft de hele dag geslapen.'",
    "options": ["heeft", "geslapen", "De hond", "hele"],
    "correctAnswer": 0,
    "explanation": "Verander de tijd: 'De hond heeft geslapen' → 'De hond had geslapen'. 'Heeft' verandert in 'had', dus 'heeft' is de persoonsvorm. Let op: 'geslapen' is het voltooid deelwoord!",
    "distractorExplanations": {
      "1": "'Geslapen' is het voltooid deelwoord. Het verandert niet als je de tijd verandert.",
      "2": "'De hond' is het onderwerp (wie heeft geslapen?).",
      "3": "'Hele' is een bijvoeglijk naamwoord."
    }
  },
  {
    "id": "SR-B7-LEESTEKEN-VRAAG-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "leestekens",
    "subSkill": "leestekens",
    "familyId": "SR-LEESTEKEN-HERKENNEN",
    "conceptId": "punctuation_recognition",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk leesteken hoort hier? 'Kom je morgen ook__'",
    "options": ["?", ".", "!", ","],
    "correctAnswer": 0,
    "explanation": "Dit is een vraagzin — er wordt iets gevraagd. Aan het eind van een vraag komt een vraagteken (?).",
    "distractorExplanations": {
      "1": "Een punt gebruik je bij een gewone mededeling, niet bij een vraag.",
      "2": "Een uitroepteken gebruik je bij een bevel of uitroep, niet bij een vraag.",
      "3": "Een komma gebruik je midden in een zin, niet aan het eind."
    }
  },
  {
    "id": "SR-B7-ONDERWERP-VADER-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "zinsontleding",
    "subSkill": "onderwerp",
    "familyId": "SR-ONDERWERP-VINDEN",
    "conceptId": "find_subject_in_sentence",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Wat is het onderwerp in de zin: 'Gisteren heeft mijn vader een taart gebakken.'",
    "options": ["mijn vader", "Gisteren", "heeft", "een taart"],
    "correctAnswer": 0,
    "explanation": "Wie heeft een taart gebakken? Mijn vader. Het onderwerp staat hier in het midden van de zin.",
    "distractorExplanations": {
      "1": "'Gisteren' is een bijwoord van tijd — het vertelt wanneer.",
      "2": "'Heeft' is de persoonsvorm.",
      "3": "'Een taart' is het lijdend voorwerp — het vertelt wat er gebakken wordt."
    }
  },
  {
    "id": "SR-B7-LEESTEKEN-UITROEP-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "leestekens",
    "subSkill": "leestekens",
    "familyId": "SR-LEESTEKEN-HERKENNEN",
    "conceptId": "punctuation_recognition",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk leesteken hoort hier? 'Stop__ Niet doen!'",
    "options": ["!", ".", "?", ","],
    "correctAnswer": 0,
    "explanation": "'Stop' is een bevel/uitroep. Daar hoort een uitroepteken (!) bij.",
    "distractorExplanations": {
      "1": "Een punt is te zwak voor een bevel. Een uitroepteken past beter.",
      "2": "Er wordt niets gevraagd, dus geen vraagteken.",
      "3": "Een komma gebruik je niet na een bevel."
    }
  },
  {
    "id": "SR-B7-PV-RENT-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "zinsontleding",
    "subSkill": "persoonsvorm",
    "familyId": "SR-PERSOONSVORM-VINDEN",
    "conceptId": "find_finite_verb",
    "variantIndex": 4,
    "questionType": "multiple_choice",
    "question": "Wat is de persoonsvorm in de zin: 'Elke ochtend rent Sophie naar school.'",
    "options": ["rent", "Elke", "Sophie", "school"],
    "correctAnswer": 0,
    "explanation": "Verander de tijd: 'Sophie rent' → 'Sophie rende'. 'Rent' verandert, dus dat is de persoonsvorm.",
    "distractorExplanations": {
      "1": "'Elke' is een bijvoeglijk naamwoord.",
      "2": "'Sophie' is het onderwerp (wie rent?).",
      "3": "'School' is een zelfstandig naamwoord."
    }
  },
  {
    "id": "SR-B7-KOMMA-BIJZIN-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "leestekens",
    "subSkill": "leestekens",
    "familyId": "SR-KOMMA-NA-BIJZIN",
    "conceptId": "comma_after_subclause",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Waar hoort een komma? 'Als het regent neem ik een paraplu mee.'",
    "options": [
      "Als het regent, neem ik een paraplu mee.",
      "Als, het regent neem ik een paraplu mee.",
      "Als het regent neem ik, een paraplu mee.",
      "Er hoeft geen komma."
    ],
    "correctAnswer": 0,
    "explanation": "Na een bijzin die vooraan staat, komt een komma. 'Als het regent' is de bijzin — daarna komt een komma vóór de hoofdzin.",
    "distractorExplanations": {
      "1": "De komma hoort niet na 'als' maar na de hele bijzin 'als het regent'.",
      "2": "De komma hoort niet midden in de hoofdzin.",
      "3": "Er hoort wél een komma. Na een bijzin vooraan komt altijd een komma."
    }
  },
  {
    "id": "SR-B7-ONDERWERP-VRAAG-V01",
    "module": "SpellingRegel",
    "difficulty": 201,
    "difficultyTier": 7,
    "levelCode": "B7",
    "group": 7,
    "skill": "zinsontleding",
    "subSkill": "onderwerp",
    "familyId": "SR-ONDERWERP-VINDEN",
    "conceptId": "find_subject_in_sentence",
    "variantIndex": 4,
    "questionType": "multiple_choice",
    "question": "Wat is het onderwerp in de vraagzin: 'Heeft jouw broer dat boek gelezen?'",
    "options": ["jouw broer", "Heeft", "dat boek", "gelezen"],
    "correctAnswer": 0,
    "explanation": "Wie heeft dat boek gelezen? Jouw broer. In een vraagzin staat het onderwerp vaak niet vooraan — de persoonsvorm staat vooraan.",
    "distractorExplanations": {
      "1": "'Heeft' is de persoonsvorm.",
      "2": "'Dat boek' is het lijdend voorwerp (wat is er gelezen?).",
      "3": "'Gelezen' is het voltooid deelwoord."
    }
  }
]